import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx } from '@emotion/core';
import { Icon } from '../Icon';

var IconWrapper = _styled("div", {
  target: "e1be10jg0",
  label: "IconWrapper"
})("display:flex;height:16px;width:16px;", function (props) {
  return __assign({
    order: props.position === 'right' ? 1 : 0
  }, props.position === 'left' ? {
    marginRight: '10px'
  } : {
    marginLeft: '10px'
  });
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

export var ButtonIcon = function ButtonIcon(_a) {
  var icon = _a.icon,
      iconOverride = _a.iconOverride,
      position = _a.position,
      props = __rest(_a, ["icon", "iconOverride", "position"]);

  if (iconOverride) {
    return jsx(IconWrapper, {
      position: position
    }, iconOverride);
  }

  if (icon) {
    return jsx(IconWrapper, {
      position: position
    }, jsx(Icon, __assign({
      content: icon,
      color: "inherit"
    }, props)));
  }

  return null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Button/ButtonIcon.js
// module id = 797
// module chunks = 0